import { message } from 'antd';
import { put, takeLatest, call } from 'redux-saga/effects';
import { ApiStatusCode } from 'api/axios';
import { TaskSourceType } from 'api/tasks';
import { deleteTaskRecord, taskCollection } from 'collections/tasks';
import { getQueryClientContext } from 'data/core/sagas/query-client';
import { removeTask } from 'data/home/slice';
import { cleanupTaskDependenciesAndRemoveFromTimeline } from 'data/projects/sagas/project/timeline';
import { addTaskToSpaceTab, removeTaskFromSpaceTab } from 'data/space-tabs';
import { getProjectDependencyMapKey } from 'queries/common';
import { deleteTaskSagaAction } from '../actions';
const isPolicyConflictError = (error)=>{
    var _error_response;
    return (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === ApiStatusCode.PolicyConflict;
};
function* deleteTaskByIdSaga({ payload }) {
    var _task_source;
    const { projectId, taskId, options } = payload;
    const task = taskCollection.get(taskId);
    const queryClient = yield getQueryClientContext();
    const spaceTabId = (task === null || task === void 0 ? void 0 : (_task_source = task.source) === null || _task_source === void 0 ? void 0 : _task_source.sourceId) && task.source.sourceType === TaskSourceType.SpaceTab ? task.source.sourceId : undefined;
    // 1) Optimistic Redux/UI that is not collection-backed
    if (spaceTabId != null) {
        yield put(removeTaskFromSpaceTab({
            spaceTabId,
            taskId
        }));
    }
    // 2) Server + collection. `deleteTaskRecord` owns the optimistic collection
    // delete and automatic rollback — do NOT `externalDelete` beforehand or the
    // task is permanently gone and the record falls onto its non-optimistic path.
    //
    // Bryntum neighbor-link cleanup MUST wait for success: it mutates other rows'
    // `dependentTasks` / `dependencies` and is not undone on refusal.
    // `useGanttStructureSync` can re-insert the deleted row after a collection
    // rollback, but it does not restore those neighbor links.
    try {
        yield call(deleteTaskRecord, projectId, taskId, options === null || options === void 0 ? void 0 : options.actor);
        yield call(cleanupTaskDependenciesAndRemoveFromTimeline, taskId);
        yield put(removeTask(taskId));
        yield queryClient.invalidateQueries(getProjectDependencyMapKey(projectId));
    } catch (error) {
        if (spaceTabId != null) {
            yield put(addTaskToSpaceTab({
                spaceTabId,
                taskId
            }));
        }
        // 422 opens the policy conflict drawer globally — skip the generic toast.
        if (!isPolicyConflictError(error)) {
            message.error('There was an error processing your request.');
        }
    }
}
export const watchDeleteTaskByIdSaga = function*() {
    yield takeLatest(deleteTaskSagaAction.type, deleteTaskByIdSaga);
};
